import {HTTP_REQUEST_AUTH} from "./requestAxios";
import {FACILITY, SCHEDULE} from "@/constants/endPoints";


export const CreateSchedule = (params) => HTTP_REQUEST_AUTH.post(SCHEDULE.CREATE_SCHEDULE, params);
export const GetListSchedule = (params) => HTTP_REQUEST_AUTH.get(SCHEDULE.GET_LIST_SCHEDULE, {params: params});
export const DeleteSchedule = (id) => HTTP_REQUEST_AUTH.delete(SCHEDULE.DELETE_SCHEDULE+ '/'+ id);
export const GetDetailSchedule = (id) => HTTP_REQUEST_AUTH.get(SCHEDULE.DETAIL_SCHEDULE+'/'+id)
export const UpdateSchedule = (id,params)=> HTTP_REQUEST_AUTH.put(SCHEDULE.UPDATE_SCHEDULE +'/'+id,params)
